import React from "react";
import spIcon from "../../assets/brand/swlogo.png";
import spWordmark from "../../assets/brand/swletters.png";

export const VerifyDocument = () => {
  
  return (
    <div className="min-h-screen grid place-items-center bg-[#fff8e1]">
      <div className="w-[412px] [font-family:'Nunito',Helvetica] text-[#5d4037]">

        {/* Title centered */}
        <h1 className="mt-6 text-center font-bold text-[18px]">Verify document</h1>

        {/* Preview rectangle */}
        <div className="w-[360px] h-[150px] mx-auto mt-6 rounded-[10px] border border-[#5d4037] bg-[#fff8e1]" />

        {/* Caption */}
        <p className="w-[360px] mx-auto mt-2 text-[14px]">Snap Front document</p>

        {/* Shutter button */}
        <div className="w-full flex flex-col items-center mt-24">
          <div className="w-16 h-16 rounded-full bg-[#5d4037] grid place-items-center relative">
            <div className="absolute inset-[3px] rounded-full border-2 border-dashed border-[#fff8e1]/90" />
          </div>
          <div className="mt-3 text-[13px] text-[#5d4037]/90">Tap to snap</div>
        </div>
      </div>
    </div>
  );
};
